/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccessCondition } from '../models/AccessCondition';
import { PermissionGrantInput } from '../models/PermissionGrantInput';

export class CreateRoleRequest {
  /**
  * Role display name. Must be unique in your Eon account. 
  */
  'name': string;
  /**
  * Permissions granted by the role.
  */
  'permissionGrants': Array<PermissionGrantInput>;
  /**
  * If present, the ID of the set of access conditions that restrict the resources the permission is granted for. The ID must be present in an entry in `accessConditions`, and the permission itself must support access conditions. If omitted, the permission is granted for all resources. 
  */
  'accessConditions'?: Array<AccessCondition>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "permissionGrants",
      "baseName": "permissionGrants",
      "type": "Array<PermissionGrantInput>",
      "format": ""
    },
    {
      "name": "accessConditions",
      "baseName": "accessConditions",
      "type": "Array<AccessCondition>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateRoleRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

